export default __webpack_public_path__ + "static/media/thumbnail_funnel_2.3bb4ff20.png";